import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useInfiniteQuery } from 'react-query';

function useUserTimeline(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getData({ pageParam = 0 } = {}) {
    return privateFetch
      .get(`/v1/admin/timeline?page=${pageParam}`, configs)
      .then((res) => res.data);
  }

  return useInfiniteQuery('user-timeline-stats', getData, {
    enabled,
    getNextPageParam(lastPage) {
      const { meta } = lastPage.data || {};
      const { page, limit, total } = meta || {};

      return page * limit < total ? page : undefined;
    },
  });
}

export default useUserTimeline;
